import ArchiveStories from '../components/ArchieveStories';
import Blog from '../components/Blog';

const BlogPage = () => {
    return <>
        <Blog />
        <ArchiveStories />
    </>
}
export default BlogPage